import LazyLoad from 'vanilla-lazyload';

export default () => ({
    video: null,
    playButtonVisible: false,
    isMuted: true,
    isPlaying: false,
    userPaused: false,

    init() {
        this.lazyLoadInstance = new LazyLoad({
            elements_selector: '.lazy',
            threshold: 0
        });

        const videoContainer = this.$refs.videoContainer;
        const selectedVideo = this.$refs.selectedVideo;

        if (selectedVideo !== null) {
            this.video = selectedVideo;
            selectedVideo.controls = false;
            selectedVideo.muted = true;

            selectedVideo.addEventListener('loadedmetadata', () => {
                this.isPlaying = !selectedVideo.paused;
            });

            const updatePlayState = () => {
                this.isPlaying = !selectedVideo.paused;
                this.playButtonVisible = this.userPaused && selectedVideo.paused;
            };

            const handlePlayPause = () => {
                if (selectedVideo.paused) {
                    selectedVideo.play();
                    this.userPaused = false;
                } else {
                    selectedVideo.pause();
                    this.userPaused = true;
                }
                updatePlayState();
            };

            selectedVideo.addEventListener('play', () => requestAnimationFrame(updatePlayState));
            selectedVideo.addEventListener('pause', () => requestAnimationFrame(updatePlayState));

            const playOnHover = selectedVideo.getAttribute('data-play-on-hover') === "true";

            if (playOnHover) {
                selectedVideo.pause();
                this.playButtonVisible = true;
            }

            this.lazyLoadInstance.update();

            this.$refs.audioToggle?.addEventListener('click', () => {
                this.isMuted = !this.isMuted;
                selectedVideo.muted = this.isMuted;
            });

            if (playOnHover) {
                const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

                if (isTouchDevice) {
                    videoContainer.addEventListener('click', handlePlayPause);
                } else {
                    videoContainer.addEventListener('mouseover', () => {
                        if (!this.userPaused) {
                            selectedVideo.play().then(updatePlayState);
                        }
                    });

                    videoContainer.addEventListener('mouseout', () => {
                        if (!this.userPaused) {
                            selectedVideo.pause();
                            updatePlayState();
                        }
                    });
                }
            }

            this.$refs.playPause?.addEventListener('click', handlePlayPause);

            this.$refs.restart?.addEventListener('click', () => {
                selectedVideo.currentTime = 0;
                updatePlayState();
            });
        }
    }
});